<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-move-up-icon lucide-move-up">
    <path d="M8 6L12 2L16 6"/>
    <path d="M12 2V22"/>
  </svg>
</template>
<script lang="ts">
import {useScreenSize} from "@/composable/useScreenSize.js";
export default {
  name: 'IconArrowUp',
  props: {
    color: {
      type: String,
      required: false,
      default: () => '#909090'
    },
  },
  setup() {
    const { width, isSmallScreen } = useScreenSize(1024);
    return {
      width,
      isSmallScreen,
    }
  }
}
</script>